import * as cs from "../Api/cs"


export const getAllBadges = async (headers = null) => {
    const response = await cs.get('getAllBadges', 'badge', null, null)
    return response?.data?.data || [];
}